// Opening the Shopify iOS app from the browser by its custom URL scheme.
// A script redirect to a scheme can open an app where a script redirect to a
// Universal Link (https) cannot. Unverified on a device: see ReturnProbe.

/** THE candidate the saved screen tries on iOS. Swap after the device test (ids in `schemeCandidates`). */
export const IOS_SCHEME_VARIANT = "host";

const ADMIN = "https://admin.shopify.com";

/** The https admin URL as a scheme URL of the given variant. Null when not an admin URL. */
export function schemeFor(variant, httpsUrl) {
  if (typeof httpsUrl !== "string" || !httpsUrl.startsWith(ADMIN + "/")) return null;
  const rest = httpsUrl.slice(ADMIN.length); // /store/<h>/apps/<key>/...
  const m = rest.match(/^\/store\/([^/]+)\/apps\/(.*)$/);
  if (!m) return null;
  const [, h, tail] = m;
  const map = {
    host: `shopify://admin.shopify.com${rest}`,
    store: `shopify://store/${h}/apps/${tail}`,
    admin: `shopify://admin/apps/${tail}`,
    myshopify: `shopify://${h}.myshopify.com/admin/apps/${tail}`,
    colon: `shopify:admin/apps/${tail}`,
    mobile: `shopify-mobile://store/${h}/apps/${tail}`,
    bare: "shopify://",
    "mobile-bare": "shopify-mobile://",
  };
  return map[variant] || null;
}

export const SCHEME_VARIANTS = ["host", "store", "admin", "myshopify", "colon", "mobile", "bare", "mobile-bare"];

/**
 * Navigate to `url` and report whether the page went hidden within `ms`
 * (the app opened) or not. Resolves once; never throws.
 * @returns {Promise<{opened: boolean, ms: number}>}
 */
export function tryNavigate(url, { ms = 1500, nav = (u) => { window.location.href = u; } } = {}) {
  return new Promise((resolve) => {
    const t0 = Date.now();
    let done = false;
    const finish = (opened) => {
      if (done) return;
      done = true;
      document.removeEventListener("visibilitychange", onVis);
      window.removeEventListener("pagehide", onHide);
      clearTimeout(timer);
      resolve({ opened, ms: Date.now() - t0 });
    };
    const onVis = () => { if (document.visibilityState === "hidden") finish(true); };
    const onHide = () => finish(true);
    document.addEventListener("visibilitychange", onVis);
    window.addEventListener("pagehide", onHide);
    const timer = setTimeout(() => finish(false), ms);
    try { nav(url); } catch { finish(false); }
  });
}
